import React, { useEffect, useState } from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  Spinner,
} from "@chakra-ui/react";

import edit_icon_dark from "../../assets/images/icons/edit_icon_dark.png";

import check_icon from "../../assets/images/icons/check_icon.png";
import cross_dark_icon from "../../assets/images/icons/cross_dark_icon.png";

import PatchUserDetailsUpdate from "services/PatchUserDetailsUpdate";
import PasswordInput from "components/PasswordInput/PasswordInput";

export default function EditProfileModal(props) {
  const { isOpen, onClose, userDataProp, setCheckUpdate } = props;

  const [userData, setUserData] = useState(userDataProp);

  const [loading, setLoading] = useState(false);

  const [firstName, setFirstName] = useState(userData?.first_name);
  const [lastName, setLastName] = useState(userData?.last_name);
  const [email, setEmail] = useState(userData?.user_email);
  const [password, setPassword] = useState("");
  const [passwordRepeat, setPasswordRepeat] = useState("");

  const [errorText, setErrorText] = useState("");

  const containsNumbers = (str) => /\d/.test(str);

  useEffect(() => {
    setUserData(userDataProp);
  }, [userDataProp]);

  const validateInputs = () => {
    if (password.length > 0) {
      if (password && password !== passwordRepeat) {
        setErrorText("Passwords do not match");
        return false;
      }
      if (password.length < 8) {
        setErrorText("Password must be at least 8 characters long");
        return false;
      }
    }

    if (email !== userData.user_email) {
      if (!/\S+@\S+\.\S+/.test(email)) {
        setErrorText("Please enter a valid email address");
        return false;
      }
    }

    if (firstName === "" || containsNumbers(firstName)) {
      setErrorText("Invalid First Name");
      return false;
    }

    if (lastName === "" || containsNumbers(lastName)) {
      setErrorText("Invalid Last Name");
      return false;
    }

    return true;
  };

  const handleSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();

    const formData = new FormData(event.target);

    if (!validateInputs()) {
      setLoading(false);
      return;
    }

    try {
      const res = await PatchUserDetailsUpdate(formData);

      if (res.status === 200) {
        onClose();

        setCheckUpdate((prev) => !prev);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }

    return;
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <div className="flex flex-row gap-2">
              <div className="h-6 w-6  flex flex-col justify-center ">
                <img src={edit_icon_dark} />
              </div>

              <h4>Edit Profile</h4>
            </div>
            <ModalCloseButton />
          </ModalHeader>

          <form onSubmit={(e) => handleSubmit(e)}>
            <ModalBody sx={{ padding: "2rem" }}>
              <div className="flex flex-col gap-5">
                <div>
                  {errorText && (
                    <p className="text-red-500 font-bold">{errorText}</p>
                  )}
                </div>
                <div className="flex flex-col md:flex-row justify-between gap-1">
                  <div className="md:w-[15rem]  ">
                    <p className="label">First Name</p>
                    <Input
                      type="text"
                      name="first_name"
                      placeholder=" "
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      //   width={"15rem"}
                    />
                  </div>
                  <div className="md:w-[15rem]">
                    <p className="label">Last Name</p>
                    <Input
                      type="text"
                      name="last_name"
                      placeholder=" "
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                  </div>
                </div>
                {/* <div>
                  <p className="label">Email</p>
                  <Input
                    name="user_email"
                    type="text"
                    placeholder=" "
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div> */}
                {/* <div>
                  <p className="label">Enter New Password</p>
                  <PasswordInput
                    name="user_password"
                    type="text"
                    placeholder=" "
                    value={password}
                    onChange={setPassword}
                  />
                </div>
                <div>
                  <p className="label">Confirm New Password</p>
                  <PasswordInput
                    name="user_password_repeat"
                    type="text"
                    placeholder=" "
                    value={passwordRepeat}
                    onChange={setPasswordRepeat}
                  />
                </div> */}
              </div>
            </ModalBody>

            <ModalFooter>
              <div className="flex flex-row justify-end gap-2">
                <div className="h-[3.13]">
                  <Button
                    sx={{ height: "3.13rem" }}
                    variant="ghost"
                    onClick={onClose}
                  >
                    <img className="mr-2" src={cross_dark_icon} /> Cancel
                  </Button>
                </div>

                <div className="w-[10rem] h-[3.13]">
                  <Button type="submit" isDisabled={loading}>
                    {!loading ? (
                      <>
                        <img
                          className="mr-2"
                          alt="Tick Icon"
                          src={check_icon}
                        />
                        Update
                      </>
                    ) : (
                      <>{<Spinner size="sm" />}</>
                    )}
                  </Button>
                </div>
              </div>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
}
